(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9692],{

/***/ 44080:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
}), 'Lock');

exports.Z = _default;

/***/ }),

/***/ 29087:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/app/tools/cluster-keywords",
      function () {
        return __webpack_require__(12464);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 12464:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _src_components_content_ai_tools_components_ToolsStyleWrapper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97344);
/* harmony import */ var _src_components_content_ai_tools_ClusterKeywords__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31153);



var PublicDiscoveryKeywordsWrapped = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_components_content_ai_tools_components_ToolsStyleWrapper__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
        component: _src_components_content_ai_tools_ClusterKeywords__WEBPACK_IMPORTED_MODULE_2__/* .ClusterKeywords */ .m
    });
};
/* harmony default export */ __webpack_exports__["default"] = (PublicDiscoveryKeywordsWrapped);


/***/ }),

/***/ 62412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64436);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39803);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85639);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30585);



var CustomerDropDownWithLock = function(param) {
    var value = param.value, options = param.options, classes = param.classes, error = param.error, onChange = param.onChange, label = param.label;
    var getOptionName = function(option) {
        return typeof option === "object" && option !== null && "name" in option ? option.name : option;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        fullWidth: true,
        error: Boolean(error),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                fullWidth: true,
                select: true,
                label: label,
                variant: "outlined",
                value: value,
                onChange: onChange,
                className: "".concat(classes.dropDown, " no-border"),
                SelectProps: {
                    MenuProps: {
                        getContentAnchorEl: null,
                        anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left"
                        }
                    },
                    renderValue: function(selected) {
                        var selectedOption = options.find(function(option) {
                            return getOptionName(option) === selected;
                        });
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            style: {
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                width: "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: selectedOption && getOptionName(selectedOption)
                                    })
                                }),
                                selectedOption && typeof selectedOption === "object" && selectedOption.icon
                            ]
                        });
                    },
                    inputProps: {
                        style: {
                            backgroundColor: "#fff",
                            borderRadius: "4px !important",
                            padding: "16px"
                        },
                        disableUnderline: true
                    }
                },
                error: Boolean(error),
                children: options.map(function(option, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        value: typeof option === "object" && option !== null && "name" in option ? option.name : option,
                        className: classes.dropDownOption,
                        disabled: typeof option === "object" && option !== null && "name" in option && option.disabled,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            style: {
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                width: "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: typeof option === "object" && option !== null && "name" in option ? option.name : option
                                }),
                                typeof option === "object" && option !== null && "icon" in option && option.icon
                            ]
                        })
                    }, index);
                })
            }),
            error ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                children: error
            }) : null
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CustomerDropDownWithLock);


/***/ }),

/***/ 53041:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kf": function() { return /* binding */ getKeywordSuitabilityRatingColorRange; },
/* harmony export */   "Mj": function() { return /* binding */ isSuggestedElementsHaveChild; },
/* harmony export */   "Uk": function() { return /* binding */ getKeywordTypeCount; },
/* harmony export */   "XP": function() { return /* binding */ getKeywordDificultyColorRange; }
/* harmony export */ });
/* unused harmony exports getHeaderString, getPotentialHeaderString, getRecalculateCountString */
var isSuggestedElementsHaveChild = function(elementId, storedPageAllHtmlData) {
    var ref;
    var findParentEleDetails = storedPageAllHtmlData.find(function(el) {
        return el.id === elementId;
    });
    var isSiblingsAvailable = false;
    if (findParentEleDetails && (findParentEleDetails === null || findParentEleDetails === void 0 ? void 0 : (ref = findParentEleDetails.siblings) === null || ref === void 0 ? void 0 : ref.length) > 0) {
        findParentEleDetails.siblings.forEach(function(sibElement) {
            for(var i = 0; i < storedPageAllHtmlData.length; i++){
                if (storedPageAllHtmlData[i].id == sibElement.id) {
                    isSiblingsAvailable = true;
                    break;
                }
            }
        });
    }
    return isSiblingsAvailable;
};
var getKeywordDificultyColorRange = function(score) {
    switch(true){
        case score <= 24:
            return "#EFBF2E";
        case score <= 49:
            return "#F2994A";
        case score <= 74:
            return "#E57310";
        case score <= 90:
            return "#EB5757";
        case score <= 100:
            return "#EB5757";
        default:
            return "";
    }
};
var getKeywordSuitabilityRatingColorRange = function(score) {
    switch(true){
        case score <= 49:
            return "#E57310";
        case score > 49 && score < 80:
            return "#EFBF2E";
        case score >= 80:
            //#219653
            return "#51D497";
        default:
            return "";
    }
};
var getKeywordTypeCount = function(list) {
    var brandedCount = 0;
    var nonBrandedCount = 0;
    // skip subkeywords
    var keywordClusterList = list.filter(function(kw) {
        return !kw.sub_keyword;
    });
    keywordClusterList.forEach(function(item) {
        if (item.is_branded) {
            brandedCount++;
        } else {
            nonBrandedCount++;
        }
    });
    return {
        brandedTargetedKeywordCount: brandedCount,
        nonBrandedTargetedKeywordCount: nonBrandedCount
    };
};
var getHeaderString = function(details, isBrandedIncluded) {
    var countArray = [];
    if (details.nonBrandedTargetedKeywordCount) {
        countArray.push("".concat(details.nonBrandedTargetedKeywordCount, " non-branded keywords"));
    }
    if (details.brandedTargetedKeywordCount && isBrandedIncluded) {
        countArray.push("".concat(details.brandedTargetedKeywordCount, " branded keywords"));
    }
    if (details.newKeywordsCount) {
        countArray.push("".concat(details.newKeywordsCount, " new non-branded keywords"));
    }
    if (details.newBrandedKeywordsCount && isBrandedIncluded) {
        countArray.push("".concat(details.newBrandedKeywordsCount, " new branded keywords"));
    }
    return countArray.join(", ");
};
var getPotentialHeaderString = function(potentialData, isBrandedIncluded) {
    var dataDetails = getKeywordTypeCount(potentialData);
    var countArray = [];
    if (dataDetails.nonBrandedTargetedKeywordCount) {
        countArray.push("".concat(dataDetails.nonBrandedTargetedKeywordCount, " non-branded keywords"));
    }
    if (dataDetails.brandedTargetedKeywordCount && isBrandedIncluded) {
        countArray.push("".concat(dataDetails.brandedTargetedKeywordCount, " branded keywords"));
    }
    return countArray.join(", ");
};
var getRecalculateCountString = function(targetdKeywordCountData) {
    var countArray = [];
    if (targetdKeywordCountData.newKeywordsCount) {
        countArray.push("".concat(targetdKeywordCountData.newKeywordsCount, " non-branded"));
    }
    if (targetdKeywordCountData.newBrandedKeywordsCount) {
        countArray.push("".concat(targetdKeywordCountData.newBrandedKeywordsCount, " branded"));
    }
    return countArray.join(", ");
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5365,4593,6787,9082,7451,4977,1875,3489,2061,1153,9774,2888,179], function() { return __webpack_exec__(29087); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);